import { Injectable, signal } from '@angular/core';
import { Dokument } from '@features/letpensiondk/letpensiondk-dokumenter/dokument.model';

@Injectable({
  providedIn: 'root'
})
export class DokumenterService  {
  selectedDokument = signal<Dokument | undefined>(undefined);
  activeTab = signal('list');
  mode = signal('update');

  selectDokument(dokument: Dokument) {
    this.mode.set('update');
    this.selectedDokument.set(dokument);

    if (dokument) {
      this.activeTab.set('detail');
    }
  }

  opretDokument() {
    this.mode.set('create');
    this.selectedDokument.set(undefined);
    this.activeTab.set('detail');
  }


}
